import { Share2, Facebook, MessageCircle, Twitter } from "lucide-react";

const PAGE_URL = typeof window !== "undefined" ? window.location.origin : "";
const SHARE_TEXT = "Cinegética Ruta del Agua de Guillena · Club de Caza — sorteos, aguardos, recechos y ofertas para socios. Échale un vistazo:";

const LINKS = [
  {
    label: "WhatsApp",
    icon: MessageCircle,
    href: `https://wa.me/?text=${encodeURIComponent(SHARE_TEXT + " " + PAGE_URL)}`,
    testid: "share-whatsapp",
  },
  {
    label: "Facebook",
    icon: Facebook,
    href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(PAGE_URL)}`,
    testid: "share-facebook",
  },
  {
    label: "X",
    icon: Twitter,
    href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(SHARE_TEXT)}&url=${encodeURIComponent(PAGE_URL)}`,
    testid: "share-x",
  },
];

export default function ShareBar() {
  return (
    <div className="flex items-center gap-4" data-testid="share-bar">
      <span className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-white/40">
        <Share2 size={14} strokeWidth={1.5} className="text-gold" /> Comparte
      </span>
      {LINKS.map((l) => (
        <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer"
          className="text-white/50 hover:text-gold transition-colors duration-200"
          data-testid={l.testid} aria-label={`Compartir en ${l.label}`}>
          <l.icon size={19} strokeWidth={1.5} />
        </a>
      ))}
    </div>
  );
}
